<svg-icon [key]="infoIconKey" [class]="colorClass" [size]="size"></svg-icon>
